<script>
import { required } from "vuelidate/lib/validators";
import Repositories from "@/repositories";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      actionForm: {},
      actionFormSubmit: false,
      save: null,
      close: null,
      repository: null
    };
  },
  created() {
    this.repository = Repositories.get("clientactions", this.$parent.$route.params.organisationcode);
  },
  methods: {
    openEditClientActionModal: function (action) {
      this.actionForm.idPublic = action.idPublic;
      this.actionForm.description = action.description;
      this.actionForm.displayOrder = action.displayOrder;
      this.actionForm.isDone = action.isDone;
      return new Promise((resolve, reject) => {
        this.save = () => {
          this.actionFormSubmit = true;
          this.$v.actionForm.$touch();
          if (!this.$v.actionForm.$invalid) {
            this.isLoading = true;
            this.repository.update(this.actionForm).then((response) => {
              resolve(response.data);
            })
          }
        };
        this.close = () => {
          reject();
        };
        this.showModal = true;
      }).finally(() => {
        this.actionFormSubmit = false;
        this.showModal = false;
        this.isLoading = false;
      })
    }
  },
  validations: {
    actionForm: {
      description: { required }
    }
  }
};
</script>

<template>
  <b-modal v-model="showModal" :title="$t('general.clientactions')" title-class="text-black font-18" hide-footer
    body-class="p-3" size="sm">
    <loading :active.sync="isLoading" :can-cancel="false" color='#f1b44c' :width=70 :height=70 loader='dots'
      :is-full-page="true">
    </loading>
    <b-form>
      <div class="row">
        <b-form-group style="position:relative;" class="col-12">
          <label>{{ $t('general.action') }}</label>
          <b-form-input v-model="actionForm.description"
            :class="{ 'is-invalid': actionFormSubmit && $v.actionForm.description.$error }"
            :placeholder="$t('general.action')">
          </b-form-input>
          <div v-if="actionFormSubmit && $v.actionForm.description.$error" class="invalid-feedback">
            <span v-if="!$v.actionForm.description.required">{{ $t('general.requiredValue') }}</span>
          </div>
        </b-form-group>
      </div>
      <div class="text-right pt-3">
        <b-button variant="light" @click="close">{{ $t('general.close') }}</b-button>
        <b-button class="ml-1" variant="success" @click="save">{{ $t('general.save') }}</b-button>
      </div>
    </b-form>
  </b-modal>
</template>